import { useNoIndexPage } from "@/lib/use-no-index-page"

/** Applies noindex/nofollow while mounted — for legal and other non-marketing pages. */
export function NoIndexHead() {
  useNoIndexPage()
  return null
}
